import Vue from 'vue';
import payDialog from './payDialog';

let instance;

const fnTypes = ['show'];

const PayDialogConstruct = Vue.extend(payDialog);

const PayDialog = function(options = {}) {
  if (!instance) {
    console.log('初始化');
    instance = new PayDialogConstruct({
      data: options
    });
    instance.$mount();
    document.body.appendChild(instance.$el);
  } else {
    Object.assign(instance.$data, options);
  }
  return instance;
};

fnTypes.forEach(type => {
  PayDialog[type] = options => PayDialog(options)[type]();
});

PayDialog.hide = () => {
  instance && instance.close();
};

PayDialog.destroy = () => {
  instance && instance.destroy();
};

export default PayDialog;
